module.exports = __webpack_public_path__ + "static/media/cancel.5c1f091d.svg";